import { render, staticRenderFns } from "./ficherosEnvio.vue?vue&type=template&id=711f8516"
import script from "./ficherosEnvio.vue?vue&type=script&lang=ts"
export * from "./ficherosEnvio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports